 $(document).ready(function() {
   $('.custom-mob-faq-heading').on('click', function() {
        $(".custom-mob-faq-heading").removeClass("active-mobile");
        $(this).addClass("active-mobile");
    });
$(".faq-heading-inner-1").click(function() {
    $('html, body').animate({
        scrollTop: $("#about").offset().top-100
    }, 100);
});
});

var faqsMain = document.getElementById("main-faq-outer");
var btns = faqsMain.getElementsByClassName("faq-heading-inner");
for (var i = 0; i < btns.length; i++) {
  btns[i].addEventListener("click", function() {
  var current = document.getElementsByClassName("active");
  current[0].className = current[0].className.replace(" active", "");
  this.className += " active";
  });
}
var acc = document.getElementsByClassName("faq-accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      var isActive = this.classList.contains("active");

      // Close all accordions
      var allPanels = document.getElementsByClassName("product-decs-panel");
      for (var j = 0; j < allPanels.length; j++) {
        allPanels[j].style.display = "none";
      }

      // Remove active class from all accordions
      var allAccordions = document.getElementsByClassName("faq-accordion");
      for (var k = 0; k < allAccordions.length; k++) {
        allAccordions[k].classList.remove("active");
      }
      if (!isActive) {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        panel.style.display = "block";
      }
    });
  }
  document.addEventListener("DOMContentLoaded", function() {
    const selectMenu = document.querySelector('.select-menu');
    const selectedOption = selectMenu.querySelector('.selected-option');
    const optionsList = selectMenu.querySelector('.options');
    const options = selectMenu.querySelectorAll('.option');
    selectedOption.addEventListener('click', function() {
      optionsList.classList.toggle('show');
    });
    options.forEach(option => {
      option.addEventListener('click', function() {
        const value = option.getAttribute('data-value');
        selectedOption.textContent = option.textContent;
        optionsList.classList.remove('show');
      });
    });

    document.addEventListener('click', function(e) {
      if (!selectMenu.contains(e.target)) {
        optionsList.classList.remove('show');
      }
    });
  });


